import React from "react";
// @material-ui/core components
import FormLabel from "@material-ui/core/FormLabel";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";

// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { getAddress, isAddress } from "ethers/lib/utils.js";
import { Controller, useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { paymentCoinService } from "services/paymentCoinService";
import { ethers } from "ethers";
import Select from "components/Select/Select";
import { chainOptions } from "const";

const useStyles = makeStyles(styles);
const chainNetwork = process.env.REACT_APP_NETWORK;

export default function PaymentCoinCreate() {
  const { register: coin, handleSubmit, setValue, watch, control } = useForm();
  const { id } = useParams();
  const history = useHistory();
  const [wallet, setWallet] = React.useState("");

  const connectWallet = async () => {
    const { ethereum } = window;
    if (ethereum.isMetaMask) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const accounts = await provider.send("eth_requestAccounts", []);
      setWallet(accounts[0]);
    } else {
      console.log("Install MetaMask");
    }
  };

  async function create(payload) {
    try {
      if (!isAddress(payload.address)) {
        toast.error("Please check address again");
        return;
      }

      await paymentCoinService.create({
        ...payload,
        volumeRate: parseFloat(payload.volumeRate),
        address: getAddress(payload.address),
      });
      toast.success("Created successful");
    } catch (e) {
      toast.error(e?.response?.data?.message[0]);
      console.log(e);
    }
  }

  async function update(payload) {
    try {
      if (!isAddress(payload.address)) {
        toast.error("Please check address again");
        return;
      }
      await paymentCoinService.update(id, {
        ...payload,
        volumeRate: parseFloat(payload.volumeRate),
        address: getAddress(payload.address),
        chainId: payload?.chainId || 25,
      });
      toast.success("Updated successful");
    } catch (e) {
      toast.error(e?.response?.data?.message[0] || "Cannot update");
      console.log(e);
    }
  }

  async function onSubmit(form) {
    if (id) {
      update(form);
    } else {
      create(form);
    }
  }

  async function fetchPaymentCoins() {
    try {
      const { data } = await paymentCoinService.getCoinById(id);
      const fields = ["name", "address", "volumeRate", "chainId"];
      fields.forEach((field) => setValue(field, data[field]));
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    if (id) {
      fetchPaymentCoins();
    }
  }, [id]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Contacts />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {!id ? "Create Payment Coin" : "Edit Payment Coin"}
            </h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Name
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...coin("name"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Address
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...coin("address"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        Chain
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <Controller
                        control={control}
                        name="chainId"
                        render={({ field: { value, onChange } }) => (
                          <Select
                            name="chainId"
                            label=""
                            onChange={onChange}
                            value={value ?? ""}
                            options={chainOptions()}
                          />
                        )}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            justifyContent: "center",
                          }}
                        >
                          <p>Volume rate</p>
                          <small style={{ marginLeft: "5px" }}>
                            {1} {watch("name") || "COIN"}= {watch("volumeRate")}{" "}
                            {chainNetwork === "cronos" ? "CRO" : "POL"}
                          </small>
                        </div>
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-end",
                          gap: "5px;",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <CustomInput
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              type: "number",
                              step: "0.0001",
                              ...coin("volumeRate"),
                            }}
                          />
                          <p style={{ marginLeft: "5px" }}>
                            {chainNetwork === "cronos" ? "CRO" : "POL"}
                          </p>
                        </div>
                      </div>
                    </GridItem>
                  </GridContainer>

                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={9}>
                      <Button onClick={() => history.goBack()}>Cancel</Button>
                      {wallet ? (
                        <Button color="rose" type="submit">
                          Submit
                        </Button>
                      ) : (
                        <Button color="rose" onClick={connectWallet}>
                          Connect Wallet
                        </Button>
                      )}
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}></GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
